import max from 'lodash/max';

import {
  PERIOD,
  PROVIDERS,
  PROVIDER_OPTION,
} from '../../../common/Charts/constants';
import { VITALS_ACTIVITY_TYPE } from '../../constants';
import { COLORS } from '../../../../constants/styles';
import { POINT_WITHOUT_HOVER } from '../../../common/Charts/options';

const { RESPIRATORY_RATE } = VITALS_ACTIVITY_TYPE;

const DEFAULTS = {
  radius: 3.5,
  showLine: false,
  borderWidth: 1.5,
  pointStyle: 'rectRot',
  backgroundColor: 'transparent',
};

const CCD_BASE = {
  ...DEFAULTS,
  borderColor: COLORS.orangeRed,
  pointBackgroundColor: COLORS.orangeRed,
};

const CDD_BY_PERIOD = {
  [PERIOD.DAY]: {
    ...CCD_BASE,
  },
  [PERIOD.WEEK]: {
    ...CCD_BASE,
  },
  [PERIOD.MONTH]: {
    ...CCD_BASE,
  },
  [PERIOD.QUARTER]: {
    ...CCD_BASE,
    ...POINT_WITHOUT_HOVER,
    showLine: true,
  },
  [PERIOD.YEAR]: {
    ...CCD_BASE,
    ...POINT_WITHOUT_HOVER,
    showLine: true,
  },
};

const DEVICE_BASE = {
  ...DEFAULTS,
  pointStyle: 'circle',
  borderColor: COLORS.black,
  pointBackgroundColor: COLORS.black,
};

const DEVICE_BY_PERIOD = {
  [PERIOD.DAY]: {
    ...DEVICE_BASE,
  },
  [PERIOD.WEEK]: {
    ...DEVICE_BASE,
  },
  [PERIOD.MONTH]: {
    ...DEVICE_BASE,
  },
  [PERIOD.QUARTER]: {
    ...DEVICE_BASE,
    ...POINT_WITHOUT_HOVER,
    showLine: true,
  },
  [PERIOD.YEAR]: {
    ...DEVICE_BASE,
    ...POINT_WITHOUT_HOVER,
    showLine: true,
  },
};

const {
  NAME,
  ICON,
  OPTIONS,
  RESOURCES,
  ACTIVE_ICON,
  DISABLED_ICON,
  SINGLE_VALUE_ICON,
  ACTIVE_SINGLE_VALUE_ICON,
} = PROVIDER_OPTION;
const { DAY, WEEK, MONTH } = PERIOD;

export const getCustomOptions = ({ period, date, formats, metric } = {}) => {
  const withPoint = [DAY, WEEK, MONTH].includes(period);

  return {
    date,
    metric,
    period,
    range: max,
    type: RESPIRATORY_RATE,
    tooltip: {
      showVerticalLine: true,
    },
    providers: {
      [PROVIDERS.DEVICES]: {
        [RESOURCES]: {
          baseValue: {
            [OPTIONS]: DEVICE_BY_PERIOD,
          },
        },
        [ICON]: withPoint
          ? 'icon-graph-devices-line-point-black'
          : 'icon-graph-line-black',
        [ACTIVE_ICON]: withPoint
          ? 'icon-graph-devices-line-point-white'
          : 'icon-graph-line-white',
        [DISABLED_ICON]: withPoint
          ? 'icon-graph-devices-line-point-disable'
          : 'icon-graph-line-disable',
        [SINGLE_VALUE_ICON]: 'icon-graph-device-point-black',
        [ACTIVE_SINGLE_VALUE_ICON]: 'icon-graph-device-point-white',
        [NAME]: formats[PROVIDERS.DEVICES],
      },
      [PROVIDERS.CCD]: {
        [RESOURCES]: {
          baseValue: {
            [OPTIONS]: CDD_BY_PERIOD,
          },
        },
        [ICON]: withPoint
          ? 'icon-graph-health-record-point-orange'
          : 'icon-graph-line',
        [ACTIVE_ICON]: withPoint
          ? 'icon-graph-health-record-point-white'
          : 'icon-graph-line-white',
        [DISABLED_ICON]: withPoint
          ? 'icon-graph-health-record-line-point-disable'
          : 'icon-graph-line-disable',
        [SINGLE_VALUE_ICON]: 'icon-graph-health-record-point-orange',
        [ACTIVE_SINGLE_VALUE_ICON]: 'icon-graph-health-record-point-white',
        [NAME]: formats[PROVIDERS.CCD],
      },
    },
  };
};



// WEBPACK FOOTER //
// ./src/components/PatientHealthboard/TimeScalableChart/RespiratoryRateChart/options.js